import { httpClient } from '@/modules/common/services/http/http-client';
import { IIncidentStatus } from './types';

export function getStatus(): Promise<IIncidentStatus> {
  return httpClient.get('api/v1/account/support/status');
}
